<template>
  <div>
    <h2>Upcoming</h2>
    <div
      v-for="inventory in upcomingInventoryList.slice(1)"
      :key="inventory.inventory_id"
      style="width:100%; float:left;  page-break-inside:avoid;  background-color:#eee;  font-size:10px; font-family:Courier; padding:5px;"
    >
      <div style="width:90%; float:left; padding-left:50px; padding-bottom:0px; font-size:12px; ">
        {{ inventory.lot_number }}-{{ inventory.lead }}
      </div>
      <div style="width:90%; float:left; padding-left:50px; padding-bottom:0px; font-size:12px;">
        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#{{ inventory.customer_bidcard_number }}&nbsp;-&nbsp;{{ inventory.customer_first_name }} {{ inventory.customer_last_name }}
      </div>
      <div style="width:430px; float:left; padding-left:50px; padding-bottom:5px; font-size:12px; ">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PHONE1:&nbsp;{{ inventory.primary_phone }}<br>
      </div>
      <div
        v-if="inventory.secondary_phone"
        style="width:430px; float:left; padding-left:50px; padding-bottom:5px; font-size:12px; "
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PHONE2:&nbsp;{{ inventory.secondary_phone }}<br>
      </div>
      <div
        v-if="inventory.backup_bid"
        style="width:210px; float:left; padding-left:10px; padding-bottom:5px; font-size:12px;"
      >
        Backup Bid:&nbsp;{{ inventory.backup_bid }}<br>
      </div>
    </div>
    <h2>Past</h2>
    <div
      v-for="inventory in pastInventoryList"
      :key="inventory.inventory_id"
      style="width:100%; float:left;  page-break-inside:avoid;  background-color:#eee;  font-size:10px; font-family:Courier; padding:5px;"
    >
      <div style="width:90%; float:left; padding-left:50px; padding-bottom:0px; font-size:12px; ">
        {{ inventory.lot_number }}-{{ inventory.lead }}
      </div>
      <div style="width:90%; float:left; padding-left:50px; padding-bottom:0px; font-size:12px;">
        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#{{ inventory.customer_bidcard_number }}&nbsp;-&nbsp;{{ inventory.customer_first_name }} {{ inventory.customer_last_name }}
      </div>
      <div style="width:430px; float:left; padding-left:50px; padding-bottom:5px; font-size:12px; ">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PHONE1:&nbsp;{{ inventory.primary_phone }}<br>
      </div>
      <div
        v-if="inventory.secondary_phone"
        style="width:430px; float:left; padding-left:50px; padding-bottom:5px; font-size:12px; "
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PHONE2:&nbsp;{{ inventory.secondary_phone }}<br>
      </div>
      <div
        v-if="inventory.backup_bid"
        style="width:210px; float:left; padding-left:10px; padding-bottom:5px; font-size:12px;"
      >
        Backup Bid:&nbsp;{{ inventory.backup_bid }}<br>
      </div>
    </div>
  </div>
</template>

<script>

export default {
	name: 'PhoneList',
	props: ['inventory_list'],
	data () {
		return {
		}
	},
	computed: {
		upcomingInventoryList: function () {
			let upcoming = []
			for(let i=0; i<this.$store.getters.phoneList.length; i++) {
				if(
					this.$store.getters.biddingStatuses['ITEMID_'+this.$store.getters.phoneList[i].inventory_id].has_passed == false &&
					this.$store.getters.biddingStatuses['ITEMID_'+this.$store.getters.phoneList[i].inventory_id].has_sold == false
				) {
					upcoming.push(this.$store.getters.phoneList[i])
				}
			}
			return upcoming
		},
		pastInventoryList: function () {
			let past = []
			for(let i=0; i<this.$store.getters.phoneList.length; i++) {
				if(
					this.$store.getters.biddingStatuses['ITEMID_'+this.$store.getters.phoneList[i].inventory_id].has_passed == true || 
					this.$store.getters.biddingStatuses['ITEMID_'+this.$store.getters.phoneList[i].inventory_id].has_sold == true
				) {
					past.push(this.$store.getters.phoneList[i])
				}
			} 
			return past
		}
	},
	mounted () {
		this.$store.dispatch('getPhoneList', {
			'auction_unique_id': this.getUrlParameter('auction_unique_id'),
			'emp': this.getUrlParameter('emp'),
			'start_lot': this.getUrlParameter('start_lot'),
			'end_lot': this.getUrlParameter('end_lot')
		})
	},
	methods: {
		getUrlParameter: function (name) {
			 
			name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
			let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
			let results = regex.exec(location.search)
			return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
		}
	}
}

</script>

<style scoped>

</style>
